import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import TimeAgo from 'javascript-time-ago'
// import { defineCustomElements } from '@ionic/pwa-elements/loader';

import en from 'javascript-time-ago/locale/en'
import { GoogleOAuthProvider } from '@react-oauth/google';
TimeAgo.addDefaultLocale(en)

// defineCustomElements(window);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  
  <GoogleOAuthProvider clientId="594027082438-bhbl9rep0eeo25l1ti9chefu6ukcvsl0.apps.googleusercontent.com">
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
